import { render, staticRenderFns } from "./card-wrapper.vue?vue&type=template&id=01d56822&scoped=true"
import script from "./card-wrapper.vue?vue&type=script&lang=ts"
export * from "./card-wrapper.vue?vue&type=script&lang=ts"
import style0 from "./card-wrapper.vue?vue&type=style&index=0&id=01d56822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d56822",
  null
  
)

export default component.exports